import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, makeStyles } from '@material-ui/core';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import ReportPdfDocument from './ReportPdfDocument';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(1),
    minWidth: 900,
    height: '85vh',
    display: 'flex',
    flexDirection: 'column'
  },
  viewer: {
    width: '100%',
    height: '100%',
    border: 'none',
  }
}));

const NewReportPrintDialog = ({ open, onClose, reportData, reportTitle, logoUrl }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Print Detail Report ({reportTitle})</DialogTitle>
      <DialogContent className={classes.content}>
        <PDFViewer className={classes.viewer}>
          <ReportPdfDocument reportData={reportData} reportTitle={reportTitle} logoUrl={logoUrl} />
        </PDFViewer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
        <PDFDownloadLink
          document={<ReportPdfDocument reportData={reportData} reportTitle={reportTitle} logoUrl={logoUrl} />}
          fileName={`report-${reportTitle ? reportTitle.replace(/\s+/g, '-') : 'export'}.pdf`}
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) => (
            <Button color="primary" variant="contained" disabled={loading}>
              {loading ? 'Preparing Document...' : 'Download PDF'}
            </Button>
          )}
        </PDFDownloadLink>
      </DialogActions>
    </Dialog>
  );
};

NewReportPrintDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  reportData: PropTypes.array,
  reportTitle: PropTypes.string,
  logoUrl: PropTypes.string,
};

export default NewReportPrintDialog;
